import state from './moduleDestinationWorkEditState.js'
import mutations from './moduleDestinationWorkEditMutations.js'
import actions from './moduleDestinationWorkEditActions.js'
import getters from './moduleDestinationWorkEditGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
